// extracted by mini-css-extract-plugin
export default {"placeHolder":"styles_placeHolder__2ICMx"};